export default "__VITE_ASSET__BUdgBX5y__"